import { FinancialServicesUIProvider } from '@shipstation/financial-services-ui-components';

import { useFsuiContext } from './fsui-context-provider';
import { useLocale } from '../intl/hooks';

/**
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @param {import('@shipstation/financial-services-ui-components').BillingInfoData} [params.initialBillingInfo]
 * @param {(billingInfo?: import('@shipstation/financial-services-ui-components').BillingInfoData) => void} [params.onBillingInfoUpdate]
 * @returns {JSX.Element}
 */
export const FinancialServicesUIProviderWrapper = ({ children, initialBillingInfo, onBillingInfoUpdate }) => {
  const { preloadedSession: initialSession, apiConfig } = useFsuiContext();
  const { locale } = useLocale();

  return (
    <FinancialServicesUIProvider
      apiConfig={apiConfig}
      billingInfo={initialBillingInfo}
      initialSession={initialSession}
      locale={locale}
      onBillingInfoUpdate={onBillingInfoUpdate}
      useMantine
    >
      {children}
    </FinancialServicesUIProvider>
  );
};
